<template>
  <div
    class="stat-widget"
  >
    <!-- <div class="title-bar">
      <div class="label">
        {{ data.label }}
      </div>

      <v-spacer />

      <v-btn
        icon
        small
        v-on:click="$emit('fetch')"
      >
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </div> -->

    <div class="content">
      <div class="value">
        <span>{{ data.value }}</span>
        <span v-if="data.uom" class="uom block">{{ data.uom }}</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: [Array, Object],
  },
}
</script>

<style lang="scss" scoped>
.stat-widget {
  display: flex;
  flex-direction: column;
  height: 100%;

  .title-bar {
    display: flex;
    padding: 0 8px;
    line-height: 28px;

    .v-btn:last-child {
      margin-right: -8px;
    }
  }

  .content {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.value {
  font-size: 1.25rem;
  text-align: center;

  .uom {
    font-size: calc(1 / 1.25 * 1rem);
    opacity: 0.8;
    margin-left: 4px;

    &.block {
      margin: 0;
      display: block;
    }
  }
}

.label {
  font-size: 12px;
  opacity: 0.8;

  // padding: 4px;
  // position: absolute;
  // top: 4px;
  // left: 4px;
}
</style>